import React from "react";
import { ReactComponent as GoogleIcon } from 'assets/images/svg/google_icon.svg';

import styles from "./style.module.scss";

import {
  Button,
} from "reactstrap";

const GoogleOAuthButton = props => {
  const { btnLabel = "Sign in with google", onClick } = props;

  return (
    <>
      <Button
        color="transparent"
        className={styles.googleButton}
        onClick={onClick}
      >
        <div class={styles.googleBtn}>
          <div class={styles.googleIconWrapper}>
            <GoogleIcon class={styles.googleIcon} />
          </div>
          <div class={styles.googleBtnText}><b>{btnLabel}</b></div>
        </div>
      </Button>
    </>
  );
}

export default GoogleOAuthButton;
